import Vue from 'vue';
import { alignForNumber, formatNumber} from '@/helpers/renderHelpers';
import {addColIdToColumns} from "@/helpers/commonHelpers";

export default {
  namespaced: true,
  state: {
    items: [],
    gridOptions: {
      animateRows: true,
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        valueFormatter: function (params) {
          return formatNumber(params.value);
        },
        cellStyle: function (params) {
          return alignForNumber(params.value);
        },
        enableValue: true,
        enableRowGroup: true,
        enablePivot: true
      },
      rowGroupPanelShow: 'always',
      groupHideOpenParents: true,
      autoGroupColumnDef: {
        filterValueGetter: function(params) {
          var colGettingGrouped = params.colDef.showRowGroup;
          var valueForOtherCol = params.api.getValue(colGettingGrouped, params.node);
          return valueForOtherCol;
        }
      },
      showToolPanel: false,
      onGridReady() {
        this.api.sizeColumnsToFit();
      }
    }
  },
  getters: {
    items(state) {
      return state.items;
    },
    gridOptions(state) {
      return state.gridOptions;
    }
  },
  mutations: {
    setData(state, data) {
      //state.items = data;
      state.gridOptions.columnDefs = addColIdToColumns(data.used_columns);
      if (state.gridOptions.api) {
        state.gridOptions.api.setColumnDefs(addColIdToColumns(data.used_columns));
        state.gridOptions.api.setRowData(data.data.results);
      }
    }
  },
  actions: {
    loadOrders(store, payload) {
      Vue.http.get('sales/search_for_sales_order/', {params: payload})
        .then(response => response.json())
        .then(data => {
          store.commit('setData', data);
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/orders.js